// extracted by mini-css-extract-plugin
export var typingIndicator = "_lk-0";